import React, { useState } from 'react'
import { useToast } from '../../lib/ui/toast'
import Spinner from '../shared/Spinner'
import { apiPost } from '../../util/api'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from '~/hooks/useTranslation'

const DropzoneCoverLetterUpload = () => {
  const { t } = useTranslation('NewCoverLetterModal')
  const [coverLetterIsUploading, setCoverLetterIsUploading] = useState(false)
  const [isDraggingOver, setIsDraggingOver] = useState(false)
  const { toast } = useToast()

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      '*/*/pdf': ['.pdf'],
      '*/*/msword': ['.doc'],
      '*/*/document': ['.docx'],
    },
    onDropAccepted: (incomingFiles) => saveNewCoverLetter(incomingFiles[0]),
    onDropRejected: (incomingFiles) => rejectionMessage(incomingFiles),
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
    onDrop: () => setIsDraggingOver(false),
    maxSize: 15_000_000, // 15MB
    disabled: coverLetterIsUploading,
  })

  const rejectionMessage = (incomingFiles) => {
    const {
      file: { type },
      errors,
    } = incomingFiles[0]
    const description = errors
      .map((e) => ` • ${t(e.code.replaceAll('-', '_'))}`)
      .join('\n')
    console.error('File upload rejected:', description)

    if (type) {
      toast({
        description,
        title: t('upload_failed'),
        variant: 'destructive',
        duration: 10_000,
      })
    }
  }

  const saveNewCoverLetter = async (file) => {
    setCoverLetterIsUploading(true)
    const name = file.name.split('.')[0]
    const formData = new FormData()
    formData.append('uploaded_cover_letter[remote_content]', file)
    formData.append('uploaded_cover_letter[name]', name)

    try {
      await apiPost(
        '/personal_brand/document/document/cover_letters_upload',
        formData,
        true,
      )
      setCoverLetterIsUploading(false)
      window.location.href = '/personal_brand/cover_letters'
      toast({ description: t('upload_success') })
    } catch (e) {
      setCoverLetterIsUploading(false)
      console.error('Error saving new cover letter', e)
      toast({
        description: t('error_upload_failed'),
        variant: 'destructive',
      })
      return
    }
  }

  const baseRootClassName =
    'min-h-[20rem] p-4 border-dashed border text-center content-center justify-items-center'
  const defaultRootClassName = isDraggingOver
    ? baseRootClassName + ' border-primary border-2 bg-lily-blue'
    : baseRootClassName
  const rootClassName = coverLetterIsUploading
    ? defaultRootClassName
    : defaultRootClassName + ' cursor-pointer'

  return (
    <div className="px-4 pb-4">
      <div className="mb-4 text-lg font-medium">
        {t('upload_your_cover_letter')}
      </div>
      <div
        {...getRootProps({
          className: rootClassName,
        })}
      >
        <input {...getInputProps()} />
        {coverLetterIsUploading && <Spinner show={true} className="w-14" />}
        {!coverLetterIsUploading && (
          <div>
            <p>{t('drag_and_drop_instruction')}</p>
            <em>{t('file_invalid_type')}</em>
          </div>
        )}
      </div>
    </div>
  )
}
export default DropzoneCoverLetterUpload
